import axios from 'axios';

const BASE_URL = process.env.REACT_APP_CONSOLE_API;
const API_KEY = process.env.REACT_APP_CONSOLE_API_KEY;

const axiosInstance = axios.create({
  baseURL: `${BASE_URL}/v1`,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY,
  },
});

// Request interceptor - attach auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        // TODO: Dispatch AUTH_LOGOUT action, redirect to sign-in
        console.warn('Authentication expired. Redirect to login.');
      }
      if (status === 403) {
        console.warn('Insufficient permissions.');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
